import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InicioComponent } from './inicio/inicio.component';
import { PrivacidadComponent } from './privacidad/privacidad.component';
import { EntrenamientosComponent } from './entrenamientos/entrenamientos.component';
import { LoginComponent } from './autenticacion/login/login.component';
import { TemporadaListComponent } from './catalogos/temporadas/temporada-list/temporada-list.component';
import { CategoriaListComponent } from './catalogos/categorias/categoria-list/categoria-list.component';
import { EquipoListComponent } from './catalogos/equipos/equipo-list/equipo-list.component';
import { CompeticionListComponent } from './catalogos/competiciones/competicion-list/competicion-list.component';
import { CompeticionesListComponent } from './competiciones/competiciones/competicion-list/competicion-list.component';
import { AgendaListComponent } from './agenda/agenda/agenda-list/agenda-list.component';
import { RolListComponent } from './catalogos/roles/rol-list/rol-list.component';
import { UsuarioListComponent } from './personas/usuarios/usuario-list/usuario-list.component';

const routes: Routes = [
    { path: '', component: InicioComponent },
    { path: 'privacidad', component: PrivacidadComponent },
    { path: 'entrenamientos', component: EntrenamientosComponent },
    { path: 'login', component: LoginComponent },
    { path: 'temporadas', component: TemporadaListComponent },
    { path: 'categorias', component: CategoriaListComponent },
    { path: 'equipos', component: EquipoListComponent },
    { path: 'competiciones', component: CompeticionListComponent },
    { path: 'agenda', component: AgendaListComponent },
    { path: 'roles', component: RolListComponent },
    { path: 'competicionesFMP', component: CompeticionesListComponent },
    { path: 'usuarios', component: UsuarioListComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
